/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Subject_Biology14Inputs */

const en__field_enum_subject_biology14 = /** @type {(inputs: _Field_Enum_Subject_Biology14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biology`)
};

const de__field_enum_subject_biology14 = /** @type {(inputs: _Field_Enum_Subject_Biology14Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Biologie`)
};

/**
* | output |
* | --- |
* | "Biology" |
*
* @param {_Field_Enum_Subject_Biology14Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_subject_biology14 = /** @type {((inputs?: _Field_Enum_Subject_Biology14Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Subject_Biology14Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_subject_biology14(inputs)
	return de__field_enum_subject_biology14(inputs)
});
export { _field_enum_subject_biology14 as "_field_enum_SUBJECT_BIOLOGY" }